import type { Writable } from '@eturi/ts-helpers'
import type { match } from 'react-router-dom'
import { resolveSerial } from '../../common'
import type { MetaAdState } from '../../reducers/landing.slice'
import { setCoupon, setGCLID, setGroupId, setMetaAttrState } from '../../reducers/landing.slice'
import { landingResolver } from '../../route-resolvers/landingResolver'

type MatchSignUpPage = Maybe<match<{ readonly groupId?: string }>>

export const resolveSignUpPage = /*@__PURE__*/ resolveSerial(
	({ dispatch }, location, match: MatchSignUpPage) => {
		const groupIdParam = match?.params.groupId
		const queryParams = new URLSearchParams(location.search)
		const [coupon, gclid, fbclid, fbc, fbp] = [
			queryParams.get('coupon'),
			queryParams.get('gclid'),
			queryParams.get('fbclid'),
			queryParams.get('fbc'),
			queryParams.get('fbp'),
		]

		// If we have a google ads attribution id, set it in state
		if (gclid) {
			dispatch(setGCLID(gclid))
		}

		// If we have a meta ads attribution id, set it in state
		if (fbclid || fbc || fbp) {
			const metaAttrState: Writable<MetaAdState> = {} as any

			if (fbclid) metaAttrState.fbclid = fbclid
			if (fbc) metaAttrState.fbc = fbc
			if (fbp) metaAttrState.fbp = fbp

			dispatch(setMetaAttrState(metaAttrState))
		}

		if (coupon) {
			dispatch(setCoupon(coupon))
		}

		if (groupIdParam) {
			dispatch(setGroupId(groupIdParam))
		}
	},
	landingResolver,
)
